// @ts-ignore
import { motion, useScroll, useSpring, useTransform } from "framer-motion";
// @ts-ignore
import React, { useRef } from "react";

import AnimatedBody from "@/animations/AnimatedBody";
import { Ivy } from "@/fonts/spaceGrotesk";

const StandartText = ({ title1, title2, desc }: { title1: string; title2: string; desc: string, parallax : number }) => {
   
    
    return (
        <div       
        className={`relative   flex flex-col items-center justify-center pointer-events-none`}>
            
        <div 
                className="mb-10  gap-5 w-[100%] text-[18px] font-bold text-center text-[#DDDACD] md:mb-16 flex flex-col  flex-center justify-center items-center md:text-[40px] leading-normal lg:mb-16 ">
               <AnimatedBody underline={true} delay={0.2} className="text-[3rem] leading-none sm:text-[5rem] font-black text-center m-0"
                    text={`${title1}`} />
                <AnimatedBody delay={0.2} className={`text-[3rem] -mt-3 leading-none pt-0 sm:text-[4rem] font-bold text-center m-0
                    ${Ivy.className}`} text={`${title2}`} />
                <AnimatedBody delay={0.2}
                    className="text-[1rem] sm:text-[1.2rem] font-normal text-center !text-opacity-100 !text-white-vibrant max-w-[450px]"
                    text={`${desc}`} />
            </div>
        </div>
    );
};

export default StandartText;
